module.exports = __webpack_public_path__ + "fonts/Gilroy-RegularItalic.b564aec8.ttf";